<template>
  <div class="bg-neutral-100 py-10 lg:py-20">
    <div class="container">
      <div class="-mx-4 lg:mx-0">
        <LazyMultipleItems :data="data.multipleEntries" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SectionMultipleRecord } from '~/types/generated'

defineProps({
  data: {
    type: Object as PropType<SectionMultipleRecord>,
    default: () => {}
  }
})
</script>
